import { React, useEffect, useState } from "react";
import AppWrapper from "../../AppWrapper";
import supabase from "../../../supabase-client";
import {
  Page,
  LegacyCard,
  IndexTable,
  Text,
  Spinner,
} from "@shopify/polaris";

function CarBrands() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function getBrands() {
      const { data, error } = await supabase
        .from("car_brands")
        .select("*, car_models(count)")
        .order("name");
      if (error) {
        console.error(error.message);
        setLoading(false);
        return;
      }
      setBrands(data);
      setLoading(false);
    }
    getBrands();
  }, []);

  const rowMarkup = brands.map((brand, index) => (
    <IndexTable.Row id={brand.id} key={brand.id} position={index}>
      <IndexTable.Cell>
        <Text fontWeight="semibold">{brand.name}</Text>
      </IndexTable.Cell>
      <IndexTable.Cell>{brand.car_models[0].count}</IndexTable.Cell>
    </IndexTable.Row>
  ));

  return (
    <AppWrapper>
      <Page title="Marcas de Autos">
        {loading ? (
          <Spinner size="small" />
        ) : (
          <LegacyCard>
            <IndexTable
              resourceName={{ singular: "Marca", plural: "Marcas" }}
              selectable={false}
              itemCount={brands.length}
              headings={[
                { title: "Marca" },
                { title: "Modelos" },
              ]}
            >
              {rowMarkup}
            </IndexTable>
          </LegacyCard>
        )}
      </Page>
    </AppWrapper>
  );
}

export default CarBrands;
